// This icon file is generated automatically.
var PAreaChartOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.88 10.38H1.12V.62A.13.13 0 001 .5H.12A.13.13 0 000 .63v10.74c0 .07.06.13.13.13h11.74c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13zm-9.63-1h8.38c.06 0 .12-.06.12-.13V2.44a.13.13 0 00-.21-.1l-3.29 3.3L5.29 3.7a.13.13 0 00-.18 0L2.16 6.66a.12.12 0 00-.04.09v2.5c0 .07.06.13.13.13z", "fill-rule": "nonzero" } }] }, "name": "p-area-chart", "theme": "outlined" };
export default PAreaChartOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PAreaChartOutlined.js
// module id = 3206
// module chunks = 0